import { ICannedResponse, INewCannedResponsePayload } from '@interfaces/cannedResponses';
import { ICannedResponseCategory } from '@interfaces/lookups';

import { apiUrls } from './urls';
import { deletes, get, post } from './utils';

export const getCannedResponseCategories = (isMedication: boolean) =>
  get<ICannedResponseCategory[]>(apiUrls.lookups.cannedResponseCategories, {
    isMedication,
  });

export const getCannedResponsesByCategory = (cannedResponseCategoryId: number) =>
  get<ICannedResponse[]>(
    `${apiUrls.cannedResponses.getCannedResponsesByCategory}/${cannedResponseCategoryId}`,
  );

export const createNewCannedResponse = (payload: INewCannedResponsePayload) =>
  post(apiUrls.cannedResponses.addCannedResponse, payload);

export const deleteCannedResponse = (cannedResponseId: number) =>
  deletes(apiUrls.cannedResponses.deleteCannedResponse, { cannedResponseId });
